// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".saledetail-dialog[data-v-9fba9e3e] {\n  height: 80%;\n}", ""]);
// Exports
module.exports = exports;
